import styled from 'styled-components';
import { rgba, lighten } from 'polished';

// CONSTANTS
import { VIOLET } from '@/constants/colors';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 116px;
  width: 116px;
  border-radius: 6px;
  background-color: ${rgba(VIOLET, 0.1)};
  padding: 14px;

  @media screen and (max-width: 1200px) {
    height: 90px;
    width: 100%;
  }

  &.service-logo-card {
    &--banner {
      position: relative;
      background-color: transparent;
      overflow: hidden;

      @media screen and (max-width: 1200px) {
        width: 90px;
      }

      img {
        position: relative;
        z-index: 2;
      }

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${p => {
          const homeColor = p.theme.palette.home.left;

          return p.theme.partnerStyles && homeColor
            ? `linear-gradient(180deg, ${lighten(0.2, homeColor)} 0%, #ffffff 100%)`
            : `linear-gradient(180deg, #babaff 0%, #ffffff 100%)`;
        }};
        opacity: 0.1;
        z-index: 1;
      }
    }
  }

  img {
    max-width: 100%;
    max-height: 100%;

    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      width: 100%;
    }
  }
`;

export default Container;
